// initial state
const state = {
    isAsset: false
}

const getters = {
    isAsset: state => state.isAsset
};

const actions = {
    disabledLayout({ commit }, data) {
        commit("disabledLayout", data);
    }
};

// mutations
const mutations = {
    disabledLayout(state, data) {
        state.isAsset = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};